
























import { Component, Vue } from 'vue-property-decorator';
import Sidebar from './components/Sidebar.vue';
import Navbar from './components/Navbar.vue';
import ActionBar from './components/ActionBar.vue';

@Component({
  name: 'Dashboard',
  components: {
    Sidebar,
    Navbar,
    ActionBar,
  },
  filters: {
    routeToTitle(value: string) {
      switch (value) {
        case 'stats':
          return 'Tổng quan';
        case 'users':
          return 'Quản lý người dùng';
        case 'products':
          return 'Sản phẩm';
        default:
          return value;
      }
    },
  },
})
export default class Dashboard extends Vue {
  private back() {
    this.$router.go(-1);
  }
}
